import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryV1 } from '../baseQueryV1';

export const settingsApi = createApi({
  reducerPath: 'settingsApi',
  baseQuery: baseQueryV1,
  tagTypes: ['Settings', 'UserIp', 'UserIpLog', 'CompanyDetails'],
  endpoints: (builder) => ({
    getSettings: builder.query({
      query: () => 'settings',
      providesTags: ['Settings'],
    }),
    updateSettings: builder.mutation({
      // <-- change from query to mutation
      query: ({ payload, id }) => ({
        url: `settings/${id}`,
        method: 'PUT',
        body: payload,
      }),
      invalidatesTags: ['Settings'], // optional: refetch settings after update
    }),
    // User IP Management endpoints
    getUserIps: builder.query({
      query: () => 'settings/user-ip',
      transformResponse: (res) => res?.data?.userIPs || [],
      providesTags: ['UserIp'],
    }),
    addUserIp: builder.mutation({
      query: (payload) => ({
        url: 'settings/user-ip',
        method: 'POST',
        body: payload,
      }),
      transformResponse: (res) => res?.data,
      invalidatesTags: ['UserIp', 'UserIpLog'],
    }),
    updateUserIp: builder.mutation({
      query: ({ id, payload }) => ({
        url: `settings/user-ip/${id}`,
        method: 'PUT',
        body: payload,
      }),
      transformResponse: (res) => res?.data,
      invalidatesTags: ['UserIp', 'UserIpLog'],
    }),
    deleteUserIp: builder.mutation({
      query: (id) => ({
        url: `settings/user-ip/${id}`,
        method: 'DELETE',
      }),
      transformResponse: (res) => res?.data,
      invalidatesTags: ['UserIp'],
    }),
    updateUserIpStatus: builder.mutation({
      query: ({ id, is_active }) => ({
        url: `settings/user-ip/${id}`,
        method: 'PUT',
        body: { is_active },
      }),
      transformResponse: (res) => res?.data,
      invalidatesTags: ['UserIp', 'UserIpLog'],
    }),
    updateUserPermissions: builder.mutation({
      query: ({ id, data }) => ({
        url: `settings/permissions/${id}`,
        method: 'PUT',
        body: data,
      }),
      transformResponse: (res) => res?.data,
      invalidatesTags: ['Settings'],
    }),

    getUserIpLogs: builder.query({
      query: ({ userIpId, pageNo = 1, pageSize = 5 }) => ({
        url: `settings/user-ip-log/${userIpId}`,
        params: { pageNo, pageSize },
      }),
      transformResponse: (res) => res?.data || { logs: [], total: 0, totalPages: 0 },
      providesTags: (result, error, { userIpId }) => [
        { type: 'UserIpLog', id: `LOG-${userIpId}` },
        { type: 'UserIpLog', id: 'LIST' },
      ],
    }),
    // Company Details endpoints
    getCompanyDetails: builder.query({
      query: () => 'settings/company-details',
      transformResponse: (res) => res?.data || {},
      providesTags: ['CompanyDetails'],
    }),
    updateCompanyDetails: builder.mutation({
      query: (payload) => ({
        url: 'settings/company-details',
        method: 'PUT',
        body: payload,
      }),
      transformResponse: (res) => res?.data,
      invalidatesTags: ['CompanyDetails'],
    }),
  }),
});

export const {
  useGetSettingsQuery,
  useUpdateSettingsMutation,
  useGetUserIpsQuery,
  useAddUserIpMutation,
  useUpdateUserIpMutation,
  useDeleteUserIpMutation,
  useUpdateUserIpStatusMutation,
  useUpdateUserPermissionsMutation,
  useGetUserIpLogsQuery,
  useGetCompanyDetailsQuery,
  useUpdateCompanyDetailsMutation,
} = settingsApi;
